import {useRef} from "react";
import {options as defaultOptions} from "../assets/asset-stats/live-chart/_options.js";
import {Chart} from "react-chartjs-2";
import {useComparatorChartData} from "./_useCoparatorChartData.js";
import './ComparatorChart.scss'
import {isMobile} from "../../util/misc.js";
import dayjs from "dayjs";
import {numberFormat} from "../../util/numbers";

const externalTooltipHandler = (context) => {
    const {chart, tooltip} = context

    let el = chart.canvas.parentNode.querySelector('.comparator-tooltip')
    if (!el) {
        el = document.createElement('div')
        el.className = 'comparator-tooltip'
        chart.canvas.parentNode.appendChild(el)
    }

    if (tooltip.opacity === 0) {
        el.style.opacity = '0'
        return
    }

    const title = dayjs(tooltip.title?.[0]).format('YYYY-MM-DD') ?? ''
    const rows = (tooltip.dataPoints ?? []).map(dp => {
        const fromValue = dp.parsed.y
        const toValue = dp.dataset.data[0]
        const change = toValue - fromValue
        const isPositive = change >= 0
        return `<div class="comparator-tooltip-row">
            <span class="comparator-tooltip-label">${dp.dataset.label}</span>
            <span class="comparator-tooltip-values">${fromValue >= 0 ? '+' : ''}${numberFormat(fromValue, 2)}<span class="pct">%</span></span>
            <span class="comparator-tooltip-change ${isPositive ? 'positive' : 'negative'}">${isPositive ? '+' : ''}${numberFormat(change, 2)}<span class="pct">%</span></span>
        </div>`
    }).join('')

    el.innerHTML = `<div class="comparator-tooltip-title">${title}</div>${rows}`

    const {offsetLeft, offsetTop} = chart.canvas
    const rawX = offsetLeft + tooltip.caretX
    const deltaPoint = tooltip.dataPoints?.find(dp => dp.dataset.label === 'Delta')
    const y = offsetTop + (deltaPoint ? deltaPoint.element.y : tooltip.caretY)
    el.style.opacity = '1'
    el.style.top = `${y}px`
    // Set left temporarily to measure width, then clamp within chart area
    el.style.left = `${rawX}px`
    const elWidth = el.offsetWidth
    const chartRight = offsetLeft + chart.chartArea.right
    const chartLeft = offsetLeft + chart.chartArea.left
    const clampedX = Math.min(Math.max(rawX, chartLeft + elWidth / 2), chartRight - elWidth / 2)
    el.style.left = `${clampedX}px`
}

export default () => {

    const chartRef = useRef()
    const {data} = useComparatorChartData(chartRef)

    const options = {
        ...defaultOptions,
        plugins: {
            ...defaultOptions.plugins,
            tooltip: {
                enabled: false,
                external: externalTooltipHandler,
            },
            eventPlugin: {
                // events: ['mouseenter', 'mouseleave'],
                // onMouseLeave: () => dispatch(setLiveChartHoverIsInactive()),
                // onMouseEnter: () => {
                // },
            },
        },
        scales: {
            x: {
                type: 'time',
                time: {
                    round: 'date',
                    displayFormats: {
                        month: 'MMMM YYYY',
                        // hour: 'MM-DD HH:ii'
                    },
                },
                border: {
                    display: false,
                },
                ticks: {
                    display: false,
                },
                grid: {
                    display: false,
                },
            },
            y: {
                beginAtZero: true,
                border: {
                    display: false,
                },
                ticks: {
                    display: !isMobile(),
                },
                grid: {
                    display: false,
                    color: function (context) {
                        if (context.tick.value > 0) {
                            return '#242424';
                        } else if (context.tick.value <= 0) {
                            return '#181818';
                        }
                        return '#000000';
                    },
                },
            }
        }
    }

    return (
        <div className='comparator-chart-area'>
            <Chart
                className={`no-select`}
                type='line'
                data={data}
                options={options}
                ref={chartRef}
            />
        </div>
    )
}